import React from "react";
// import Select from 'react-select';
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";

import Util from "../../../util/util";
import Modal from "../../common/modal";
import ATable from "../../common/table";
import Divider from "../../common/divider";
import { Spinner } from "../../common/spinner";
import FloatInput from "../../common/floatInput";
import ArbiterApi from "../../../api/ArbiterApi";
import CButton from "../../common/connectedButton";
import validators from "../../common/validatorhelpers";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";

class MerchantDisputantsModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      mapMerchant: props.isNew ? false : props.merchantDisputant.mapped,
      lengthIds: 0,
      isEdit: false,
      isDelete: false,
      updating: false,
      emailValidity: -1,
      isNew: props.isNew,
      cardAcceptorId: "",
      touchedForm: false,
      isView: !props.isNew,
      domainNameValidity: -1,
      domainCodeValidity: -1,
      addedCardAcceptors: [],
      loadingCardAcceptors: false,
      creatingCardAcceptor: false,
      merchantDisputant: props.isNew ? {} : props.merchantDisputant,
      title: props.isNew ? "New Merchant Disputant" : `Merchant Disputant`,
      updateSearchedMerchant: false,
    };

    this.modalStyle = {
      ovelay: {},
      content: {
        top: "80px",
        left: "250px",
        right: "250px",
        bottom: "100px",
        zIndex: "1000",
      },
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onTextInputChangee = this.onTextInputChangee.bind(this);
  }

  componentDidMount() {
    const merchantDisputant = this.state.merchantDisputant.id;

    if (!this.props.isNew) {
      this.setState({ loadingCardAcceptors: true });
      ArbiterApi.getCardAcceptors(merchantDisputant)
        .then((response) => {
          this.setState({ loadingCardAcceptors: false });
          this.setState({ addedCardAcceptors: response.data.content });
          // this.setState({ lengthIds : response.data.content.length})
        })
        .catch((error) => {
          Util.errorMessageToast(Toaster, error.data, [
            `${error.data ? error.data.description : error.statusText}`,
            `${Messages.ERROR_GETTING_CARD_ACCEPTOR}`,
          ]);
          this.setState({ loadingCardAcceptors: false });
        });
    }
  }

  componentDidUpdate() {
    if (this.state.addedCardAcceptors.length !== this.state.lengthIds) {
      this.setState({
        lengthIds: this.state.addedCardAcceptors.length,
      });
    }
  }

  onTextInputChange(evt) {
    let merchantDisputant = Object.assign({}, this.state.merchantDisputant);
    merchantDisputant[evt.target.id] = evt.target.value || null;

    let stateUpdate = {
      merchantDisputant,
      touchedForm: true,
    };
    stateUpdate[`${evt.target.id}Validity`] = evt ? 1 : 0;

    this.setState(stateUpdate);
  }

  onTextInputChangee(evt) {
    let stateUpdate = {};
    stateUpdate[evt.target.id] = evt.target.value;
    this.setState(stateUpdate);
  }

  handleCheckBoxChange = (e) => {
    this.setState({ mapMerchant: e.target.checked });
    this.setState({ isChecked: !this.state.isChecked });
  };
  handleAction(evt) {
    const merchantDisputant = this.state.merchantDisputant;
    const payload = { ...merchantDisputant, mapped: this.state.mapMerchant };

    this.setState({ updating: true });

    ArbiterApi.createMerchantDisputant(payload)
      .then((response) => {
        Toaster.success(Messages.SUCCESS_MERCHANT_DISPUTANT_CREATED);
        this.setState({ updating: false });
        this.props.onRequestClose(evt, true);
      })
      .catch((error) => {
        Util.errorMessageToast(Toaster, error.data, [
          `${error.data ? error.data.description : error.statusText}`,
          //   `${Messages.ERROR_MERCHANT_DISPUTANT_CREATE}`,
        ]);
        this.setState({ updating: false });
      });
  }

  handleDeleteAction(evt) {
    this.setState({ updating: true });
    const merchantDisputant = this.state.merchantDisputant;
    ArbiterApi.deleteMerchantDisputant(merchantDisputant.id)
      .then((response) => {
        Toaster.success(Messages.SUCCESS_MERCHANT_DISPUTANT_DELETE);
        this.setState({ updating: false });
        this.props.onRequestClose(evt, true);
      })
      .catch((error) => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_MERCHANT_DISPUTANT_DELETE}`,
          "",
        ]);
        this.setState({ updating: false });
      });
  }

  handleUpdateAction(evt) {
    this.setState({ updating: true });
    const merchantDisputant = this.state.merchantDisputant;
    const payload = { ...merchantDisputant, mapped: this.state.mapMerchant };
    ArbiterApi.updateMerchantDisputant(merchantDisputant.id, payload)
      .then((response) => {
        Toaster.success(Messages.SUCCESS_MERCHANT_DISPUTANT_UPDATE);
        this.setState({ updating: false });
        this.props.onRequestClose(evt, true, true);
      })
      .catch((error) => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_MERCHANT_DISPUTANT_UPDATE}`,
          "",
        ]);
        this.setState({ updating: false });
      });
  }

  handleAddCardAcceptor(evt) {
    this.setState({ creatingCardAcceptor: true });
    const id = this.state.merchantDisputant.id;
    ArbiterApi.createCardAcceptor(id, {
      cardAcceptorId: this.state.cardAcceptorId,
    })
      .then((response) => {
        Toaster.success(Messages.SUCCESS_CARD_ACCEPTOR);
        this.setState({ creatingCardAcceptor: false });
        this.setState({ cardAcceptorId: "" });
        this.props.onRequestClose(evt, true);
      })
      .catch((error) => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CARD_ACCEPTOR}`,
          "",
        ]);
        this.setState({ creatingCardAcceptor: false });
      });
  }

  render() {
    const columns = [
      { header: "S/N", render: (row) => <div>{row.viewIndex + 1}</div> },
      {
        header: "Acceptor Id",
        accessor: "cardAcceptorId",
      },
    ];
    const { isView, isDelete, isEdit } = this.state;

    return (
      <Modal
        style={this.modalStyle}
        title={this.state.title}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
      >
        <div>
          {this.state.loadingCardAcceptors && !this.props.isNew ? (
            <div>
              <Spinner className="spinner-container" />
            </div>
          ) : (
            <div>
              {isView && (
                <div className="mod-content">
                  <form>
                    <div className="row">
                      <div className="col-md-11">
                        <div className="form-div">
                          <label>Domain Code:</label>
                          <label>
                            {this.state.merchantDisputant.domainCode}
                          </label>
                        </div>
                        <div className="form-div">
                          <label>Domain Name:</label>
                          <label>
                            {this.state.merchantDisputant.domainName}
                          </label>
                        </div>
                        <div className="form-div">
                          <label>Email:</label>
                          <label style={{ width: "350px" }}>
                            {this.state.merchantDisputant.email}
                          </label>
                        </div>
                        <div className="form-div">
                          <label>Merchant status:</label>
                          <label>
                            {this.state.merchantDisputant.mapped
                              ? "Mapped"
                              : "Not Mapped"}
                          </label>
                        </div>
                      </div>
                    </div>
                  </form>
                  <Divider />
                  <div style={{ marginTop: "1rem" }}>
                    <h2>Card Acceptor</h2>
                    <div className="form-div">
                      <FloatInput
                        placeholder="Enter card acceptor id"
                        id="cardAcceptorId"
                        value={this.state.cardAcceptorId}
                        onChange={this.onTextInputChangee}
                      />
                      <button
                        className="btn btn-primary"
                        style={{ marginLeft: "0.4rem" }}
                        disabled={
                          this.state.creatingCardAcceptor ||
                          this.state.cardAcceptorId.length < 1
                        }
                        onClick={(evt) => {
                          this.handleAddCardAcceptor(evt);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div>
                      {this.state.addedCardAcceptors.length > 0 && (
                        <h2 className="card-acceptor-header">
                          Card Acceptor{" "}
                          {this.state.addedCardAcceptors.length > 1
                            ? "Id's"
                            : "Id"}
                        </h2>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {!isEdit &&
                !this.props.isNew &&
                this.state.addedCardAcceptors.length !== 0 && (
                  <ATable
                    manual
                    columns={columns}
                    showPagination={false}
                    style={{ width: "50%" }}
                    className="-striped -highlight"
                    tableData={this.state.addedCardAcceptors}
                    pageSize={this.state.addedCardAcceptors.length}
                  />
                )}
              {isEdit && !isView && (
                <div className="mod-content">
                  <form>
                    <div className="row">
                      <div className="col-md-11">
                        <div className="form-div">
                          <label>Domain Code:</label>
                          <label>
                            {this.state.merchantDisputant.domainCode}
                          </label>
                          {/* <FloatInput
                            id="domainCode"
                            value={this.state.merchantDisputant.domainCode}
                            onChange={this.onTextInputChange}
                            placeholder="Enter Domain Code"
                            maxLength="50"
                            showError={this.state.domainCodeValidity === 0}
                            errorMessage={`${Messages.INVALID_CODE}`}
                          /> */}
                        </div>
                        <div className="form-div">
                          <label className="required">Domain Name</label>
                          <FloatInput
                            id="domainName"
                            value={this.state.merchantDisputant.domainName}
                            onChange={this.onTextInputChange}
                            placeholder="Enter Domain Name"
                            maxLength="50"
                            showError={this.state.domainNameValidity === 0}
                            errorMessage={`${Messages.INVALID_NAME}`}
                          />
                        </div>
                        <div className="form-div">
                          <label>Email Address</label>
                          <FloatInput
                            id="email"
                            value={this.state.merchantDisputant.email}
                            onChange={this.onTextInputChange}
                            placeholder="Enter Email Address"
                            maxLength="255"
                            showError={this.state.emailValidity === 0}
                            errorMessage={`${Messages.INVALID_EMAIL}`}
                          />
                        </div>
                        <div className="form-div">
                          <label></label>
                          <div className="float__input form-group">
                            <input
                              type="checkbox"
                              onChange={this.handleCheckBoxChange}
                              value={this.state.merchantDisputant.mapped}
                              defaultChecked={
                                this.state.merchantDisputant.mapped
                              }
                              style={{
                                opacity: "1",
                                boxShadow: "none",
                                width: "13px",
                              }}
                            />
                            <label
                              style={{
                                paddingTop: "0.3rem",
                                paddingLeft: "1rem",
                              }}
                            >
                              Merchant mapped on ISW Core
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              )}
              {!isView && !isEdit && (
                <div className="mod-content">
                  <form>
                    <div className="row">
                      <div className="col-md-11">
                        <div className="form-div">
                          <label className="required">Domain Code</label>
                          <FloatInput
                            id="domainCode"
                            value={this.state.merchantDisputant.domainCode}
                            onChange={this.onTextInputChange}
                            placeholder="Enter Code"
                            maxLength="10"
                            showError={this.state.domainCodeValidity === 0}
                            errorMessage={`${Messages.INVALID_CODE}`}
                          />
                        </div>
                        <div className="form-div">
                          <label className="required">Domain Name</label>
                          <FloatInput
                            id="domainName"
                            value={this.state.merchantDisputant.waitTime}
                            onChange={this.onTextInputChange}
                            placeholder="Enter Domain Name"
                            maxLength="50"
                            showError={this.state.domainNameValidity === 0}
                            errorMessage={`${Messages.INVALID_NAME}`}
                          />
                        </div>
                        <div className="form-div">
                          <label>Email Address</label>
                          <FloatInput
                            id="email"
                            value={this.state.merchantDisputant.email}
                            onChange={this.onTextInputChange}
                            placeholder="Enter Email Address"
                            maxLength="255"
                            showError={this.state.emailValidity === 0}
                            errorMessage={`${Messages.INVALID_EMAIL}`}
                          />
                        </div>
                        <div className="form-div">
                          <label></label>
                          <div className="float__input form-group">
                            <input
                              type="checkbox"
                              onChange={this.handleCheckBoxChange}
                              style={{
                                opacity: "1",
                                boxShadow: "none",
                                width: "13px",
                              }}
                            />
                            <label
                              style={{
                                paddingTop: "0.3rem",
                                paddingLeft: "1rem",
                              }}
                            >
                              Merchant mapped on ISW Core
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              )}
              {!isDelete && (
                <div className="mod-footer">
                  <div className="mod-footer-buttons">
                    {isView && (
                      <CButton
                        onClick={(evt) => {
                          this.setState({ isEdit: true, isView: false });
                        }}
                        className="btn btn-primary"
                        allowedPermissions={[
                          Permissions.UPDATE_MERCHANT_DISPUTANT,
                        ]}
                      >
                        EDIT
                      </CButton>
                    )}
                    {isView && (
                      <CButton
                        onClick={(evt) => {
                          this.setState({ isDelete: true });
                        }}
                        className="btn btn-primary"
                        allowedPermissions={[
                          Permissions.DELETE_MERCHANT_DISPUTANT,
                        ]}
                      >
                        DELETE
                      </CButton>
                    )}

                    {!isView && !isEdit && (
                      <CButton
                        onClick={(evt) => {
                          this.handleAction(evt);
                        }}
                        disabled={this.state.updating || !this.formValid()}
                        className="btn btn-primary"
                        allowedPermissions={[
                          Permissions.CREATE_MERCHANT_DISPUTANT,
                        ]}
                      >
                        CREATE
                      </CButton>
                    )}
                    {!isView && isEdit && (
                      <CButton
                        onClick={(evt) => {
                          this.handleUpdateAction(evt);
                        }}
                        disabled={this.state.updating}
                        className="btn btn-primary"
                        allowedPermissions={[
                          Permissions.CREATE_MERCHANT_DISPUTANT,
                        ]}
                      >
                        UPDATE
                      </CButton>
                    )}
                    <button
                      onClick={(evt) => {
                        this.props.onRequestClose(evt);
                      }}
                      disabled={this.state.updating}
                      className="btn btn-danger"
                    >
                      CLOSE
                    </button>
                  </div>
                </div>
              )}

              {isDelete && (
                <div className="mod-footer">
                  <div className="action-warning">
                    {Messages.ACTION_WARNING} ?
                  </div>
                  <div className="mod-footer-buttons">
                    <button
                      onClick={(evt) => {
                        this.setState({ isDelete: false });
                      }}
                      disabled={this.state.updating}
                      className="btn btn-danger"
                    >
                      NO
                    </button>
                    <button
                      onClick={(evt) => {
                        this.handleDeleteAction(evt);
                      }}
                      disabled={this.state.updating}
                      className="btn btn-primary"
                    >
                      YES
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    );
  }

  formValid() {
    //Each field must have an exact validity i.e. validity must exact equal '1'
    const isValidEmail =
      validators.isValidEmail(this.state.merchantDisputant.email) ||
      !this.state.merchantDisputant.email
        ? true
        : false;
    return (
      this.state.touchedForm &&
      (this.state.domainCodeValidity === 1 || this.state.isEdit) &&
      (this.state.domainNameValidity === 1 || this.state.isEdit) &&
      isValidEmail
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(MerchantDisputantsModal, [Permissions.VIEW_MERCHANT_DISPUTANT])
);



// WEBPACK FOOTER //
// ./src/components/admin/merchantDisputants/merchantDisputantsModal.js